if (!customElements.get('product-info')) {
  customElements.define(
    'product-info',
    class ProductInfo extends HTMLElement {
      constructor() {
        super();
        this.input = this.querySelector('.quantity__input');
        this.currentVariant = this.querySelector('.product-variant-id');
        this.variantSelects = this.querySelector('variant-radios');
        this.submitButton = this.querySelector('[type="submit"]');
      }

      cartUpdateUnsubscriber = undefined;
      variantChangeUnsubscriber = undefined;

      connectedCallback() {
        if (!this.input) return;
        this.quantityForm = this.querySelector('.product-form__quantity');
        if (!this.quantityForm) return;
        this.setQuantityBoundries();
        if (!this.dataset.originalSection) {
          this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, this.fetchQuantityRules.bind(this));
        }
        this.variantChangeUnsubscriber = subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
          const sectionId = this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section;
          if (event.data.sectionId !== sectionId) return;
          this.updateQuantityRules(event.data.sectionId, event.data.html);
          this.setQuantityBoundries();
        });
      }

      disconnectedCallback() {
        if (this.cartUpdateUnsubscriber) {
          this.cartUpdateUnsubscriber();
        }
        if (this.variantChangeUnsubscriber) {
          this.variantChangeUnsubscriber();
        }
      }

      setQuantityBoundries() {
        const data = {
          cartQuantity: this.input.dataset.cartQuantity ? parseInt(this.input.dataset.cartQuantity) : 0,
          min: this.input.dataset.min ? parseInt(this.input.dataset.min) : 1,
          max: this.input.dataset.max ? parseInt(this.input.dataset.max) : null,
          step: this.input.step ? parseInt(this.input.step) : 1,
        };

        let min = data.min;
        const max = data.max === null ? data.max : data.max - data.cartQuantity;
        if (max !== null) min = Math.min(min, max);
        if (data.cartQuantity >= data.min) min = Math.min(min, data.step);

        this.input.min = min;
        this.input.max = max;
        this.input.value = min;
        publish(PUB_SUB_EVENTS.quantityUpdate, undefined);
      }

      fetchQuantityRules() {
        if (!this.currentVariant || !this.currentVariant.value) return;
        this.querySelector('.quantity__rules-cart .loading-overlay').classList.remove('hidden');
        fetch(`${this.dataset.url}?variant=${this.currentVariant.value}&section_id=${this.dataset.section}`)
          .then((response) => {
            return response.text();
          })
          .then((responseText) => {
            const html = new DOMParser().parseFromString(responseText, 'text/html');
            this.updateQuantityRules(this.dataset.section, html);
            this.setQuantityBoundries();
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.querySelector('.quantity__rules-cart .loading-overlay').classList.add('hidden');
          });
      }

      updateQuantityRules(sectionId, html) {
        const quantityFormUpdated = html.getElementById(`Quantity-Form-${sectionId}`);
        const selectors = ['.quantity__input', '.quantity__rules', '.quantity__label'];
        for (let selector of selectors) {
          const current = this.quantityForm.querySelector(selector);
          const updated = quantityFormUpdated.querySelector(selector);
          if (!current || !updated) continue;
          if (selector === '.quantity__input') {
            const attributes = ['data-cart-quantity', 'data-min', 'data-max', 'step'];
            for (let attribute of attributes) {
              const valueUpdated = updated.getAttribute(attribute);
              if (valueUpdated !== null) current.setAttribute(attribute, valueUpdated);
            }
          } else {
            current.innerHTML = updated.innerHTML;
          }
        }
      }
    }
  );
}

// console.log(document.getElementsByTagName("variant-radios")[0].id)

// console.log(document.querySelector("#variant-radios-template--17380946608378__main".replace("variant-radios-", "") + "-1-0").value)

// document.querySelector("#variant-radios-template--17380946608378__main".replace("variant-radios-", "") + "-1-0").innerHTML = "250g"

// console.log(document.getElementById("template--17380946608378__main-1-3"))
// labels = document.getElementsByTagName('label');
//    for( var i = 0; i < labels.length; i++ ) {
//       if (labels[i].htmlFor == "template--17380946608378__main-1-0") {
//            console.log(labels[i]);
//            labels[i].innerHTML = "250g";
           
//       }
//    }




function convertGrs(tagId = ""){
  if (tagId == ""){
    tagId = document.getElementsByTagName("variant-radios")[0].id.replace("variant-radios-", "")
  }
  // console.log(tagId)
  labels = document.getElementsByTagName('label');

  i = 0
  while (true) {
    currentId = tagId + "-1-" + i
    if (document.getElementById(currentId) == null){
      break;
    } 
    currentWeight = document.getElementById(currentId).value
  
  for( var j = 0; j < labels.length; j++ ) {
    if (labels[j].htmlFor == currentId) {
         labels[j].innerHTML = currentWeight
    }
 }
  i++
}
  let unitPreference = "metric"
  if (typeof(Storage) !== "undefined") {
    localStorage.setItem("unitPreference", unitPreference);
  }
  let button = document.getElementById("convert-to-grams"); 
  button.disabled = !button.disabled;
  button.classList.toggle("selected");
  
  let button2 = document.getElementById("convert-to-oz");
  button2.disabled = !button.disabled;
  if (button2.classList.contains("selected")) {
    button2.classList.toggle("selected");
  }
}

function convertOz(tagId = "") {
  if (tagId == ""){
    tagId = document.getElementsByTagName("variant-radios")[0].id.replace("variant-radios-", "")
  }
  // console.log(tagId)
  labels = document.getElementsByTagName('label');

  i = 0
  while (true) {
    currentId = tagId + "-1-" + i
    if (document.getElementById(currentId) == null){
      break;
    } 

    currentWeight = document.getElementById(currentId).value

    if (currentWeight.includes("k")) {
      newWeight = (currentWeight.replace("kg", "") * 1000 / 28.3495231).toFixed(1) + "oz";
    }
    else if (currentWeight.includes("g")) {
      newWeight = (currentWeight.replace("g", "") / 28.3495231).toFixed(1) + "oz";
    }

    else if (currentWeight.includes("ml")) {
      newWeight = (currentWeight.replace("ml", "") / 29.5735).toFixed(1) + " fl oz";
    }
    else if (currentWeight.includes("L")) {
      newWeight = (currentWeight.replace("L", "") * 1000 / 29.5735).toFixed(1) + " fl oz";
    }


    // document.getElementById(currentId).value = newWeight + "oz";

    for( var j = 0; j < labels.length; j++ ) {
      if (labels[j].htmlFor == currentId) {
           labels[j].innerHTML = newWeight
      }
   }
    i++
  }
  let unitPreference = "imperial"
  if (typeof(Storage) !== "undefined") {
    localStorage.setItem("unitPreference", unitPreference);
  }
  let button = document.getElementById("convert-to-oz");
  button.disabled = !button.disabled;
  button.classList.toggle("selected");
  let button2 = document.getElementById("convert-to-grams");
  button2.disabled = !button.disabled;
  if (button2.classList.contains("selected")) {
    button2.classList.toggle("selected");
  }
  
}

document.addEventListener("DOMContentLoaded", function() { 
  if (localStorage.getItem("unitPreference") == "metric" || localStorage.getItem("unitPreference") == null){
    convertGrs();
  }
  else if (localStorage.getItem("unitPreference") == "imperial") {
    convertOz();
  }
})